import { AsGrid } from '@adserve/adserve-react-components';
import React, { useContext, useState, useEffect } from 'react';
import { SystemSettingsContext } from '../../../contexts/SystemSettingsContext';
import { defaultPageInfo } from '../../../services/AsGridService';
import { sectionedPanelStyle } from '../CampaignStyles';
import { campaignPackageColumnDefinition } from './CampaignPackageGridColumnDefinitions';
import { sectionTitleStyle } from '../Properties/ShowStyles';
import { GetCampaignPackages } from '../../../services/CampaignsDataService';
import { AirtimePlanningContext } from '../../../contexts/AirtimePlanningContext';

const CampaignPackagesPanel = ({ campaign, campaignPackageData, onDeletePackage, readOnly = false }) => {
    const { dateFormat } = useContext(SystemSettingsContext);
    const { campaignPackages, setCampaignPackages } = useContext(AirtimePlanningContext);
    useEffect(() => {
        setCampaignPackages([...campaignPackageData]);
    }, [campaignPackageData]);
    const handleQuoteClick = (e) => {
        const id = e.target.getAttribute('data-id');

        const pack = campaign.campaignPackages.find((s) => s.id == id);
        pack.quote = !pack.quote;
        setCampaignPackages([...campaign.campaignPackages]);
    };
    const [coldefs, setColDefs] = useState(campaignPackageColumnDefinition(handleQuoteClick, false));
    const handlePrimaryColumnClick = () => {
        alert('clicked');
    };
    const handleIconDisabilty = (actionType, status, mutar) => {
        return false;
    };
    const handleActionClick = (a, b) => {
        if (a == 'delete') {
            onDeletePackage(b.id);
        }
    };
    const handleCustomClick = (a, b) => {};
    return (
        <>
            {campaignPackages?.length > -1 && (
                <div
                    style={{
                        ...sectionedPanelStyle,
                        border: '1px solid white',
                        padding: '20px 40px 40px',
                        width: '100%',
                        height: 200
                    }}
                >
                    <div style={{ marginLeft: 21 }}>
                        <span style={sectionTitleStyle}>{window.translate('Campaign Packages')}</span>
                    </div>

                    <div style={{ marginLeft: 21 }}>
                        <div id='grid'>
                            <AsGrid
                                style={{
                                    borderLeft: '1px solid rgb(215, 215, 215)'
                                }}
                                maxVisibleRows={campaignPackages?.length + 1}
                                showColumnFilter={false}
                                locale='en-GB'
                                currency='GBP'
                                dateFormat={dateFormat}
                                headerRowHeight={53}
                                pageInfo={defaultPageInfo}
                                columnDefs={coldefs}
                                data={campaignPackageData ?? []}
                                primaryColumn='propertyName'
                                onPrimaryColumnClick={handlePrimaryColumnClick}
                                onActionIconLoad={handleIconDisabilty}
                                onActionClick={handleActionClick}
                                onCustomClick={handleCustomClick}
                                maxDataRows={5}
                                maxHeight={150}
                            />
                        </div>
                    </div>
                </div>
            )}{' '}
        </>
    );
};

export default CampaignPackagesPanel;
